module.exports = __webpack_public_path__ + "images/emoji/green_heart.6878b47b339d10680173.png";